<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  />
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Configuración del sistema</custom-title>
    </template>
    <template
      v-if="activeTab === 'general'"
      #right
    >
      <el-button
        type="primary"
        size="default"
        @click="onSave"
        >Guardar</el-button
      >
    </template>
  </main-buttons-bar>
  <div class="scroll-container">
    <el-tabs
      v-model="activeTab"
      type="card"
    >
      <el-tab-pane
        label="Configuración general"
        name="general"
      >
        <el-form
          ref="formRef"
          :model="formList"
          label-position="top"
          class="form-wrapper"
        >
          <div
            v-for="group in groupedFormList"
            :key="group.claveInterna"
            class="config-group"
          >
            <div class="config-group__header">
              <div
                class="config-group__icon"
                v-html="group.icon"
              ></div>
              <div class="config-group__header-text">
                <h3 class="config-group__title">{{ group.title }}</h3>
                <p class="config-group__subtitle">{{ group.description }}</p>
              </div>
            </div>
            <div class="config-group__grid">
              <div
                v-for="item in group.regularItems"
                :key="item.config.Codigo"
                class="config-field"
              >
                <div class="config-field__label">{{ item.config.Descripcion }}</div>
                <p
                  v-if="item.ayuda"
                  class="config-field__help"
                >
                  {{ item.ayuda }}
                </p>
                <template v-if="item.config.TipoComponente?.toLowerCase() === 'select'">
                  <template v-if="item.config.ClaveInterna === 'moneda_visualizacion'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      :placeholder="`Seleccionar`"
                      clearable
                      size="default"
                    >
                      <el-option
                        v-for="moneda in monedaList"
                        :key="moneda.Codigo"
                        :label="moneda.Descripcion"
                        :value="moneda.Codigo"
                      />
                    </el-select>
                  </template>
                  <template v-else-if="item.config.ClaveInterna === 'rotacion_imposicion'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      :placeholder="`Seleccionar`"
                      clearable
                      size="default"
                    >
                      <el-option
                        v-for="rotacion in rotacionOpciones"
                        :key="rotacion.key"
                        :label="rotacion.label"
                        :value="rotacion.key"
                      />
                    </el-select>
                  </template>
                  <template v-else-if="item.config?.ClaveInterna === 'modo_calculo_precio'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="modo in calculoCotizacionOpciones"
                        :key="modo.key"
                        :label="modo.label"
                        :value="modo.key"
                      />
                    </el-select>
                  </template>
                  <template v-else-if="item.config.ClaveInterna === 'tipo_item_mezcla'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="tipo in materialTipoList"
                        :key="tipo.Codigo"
                        :label="tipo.Descripcion"
                        :value="tipo.Codigo"
                      />
                    </el-select>
                  </template>
                  <template v-else-if="item.config.ClaveInterna === 'tipo_item_componente'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="tipo in materialTipoList"
                        :key="tipo.Codigo"
                        :label="tipo.Descripcion"
                        :value="tipo.Codigo"
                      />
                    </el-select>
                  </template>
                  <template
                    v-else-if="item.config.ClaveInterna === 'categoria_item_material_resultante'"
                  >
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="categoria in materialCategoriaList"
                        :key="categoria.Codigo"
                        :label="categoria.Descripcion"
                        :value="categoria.Codigo"
                      />
                    </el-select>
                  </template>
                  <template v-else-if="item.config.ClaveInterna === 'calculo_material_extrusion'">
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opcion in calculoMaterialExtrusionOpciones"
                        :key="opcion.key"
                        :label="opcion.label"
                        :value="opcion.key"
                      />
                    </el-select>
                  </template>
                  <template
                    v-else-if="item.config.ClaveInterna === 'filtro_generico_material_defecto'"
                  >
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      clearable
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opcion in MaterialGenericoFiltroOptions"
                        :key="opcion.Codigo"
                        :label="opcion.Descripcion"
                        :value="opcion.Codigo"
                      />
                    </el-select>
                  </template>
                  <template
                    v-else-if="item.config.ClaveInterna === 'sentido_bobinado_configuracion'"
                  >
                    <el-select
                      v-model="formList[item.index].Valor"
                      placeholder="Seleccionar"
                      size="default"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="opcion in SentidoBobinadoConfiguracionOptions"
                        :key="opcion.Codigo"
                        :label="opcion.Descripcion"
                        :value="opcion.Codigo"
                      />
                    </el-select>
                  </template>
                </template>
                <template v-else-if="isImage(item.config.TipoComponente)">
                  <div class="img-field">
                    <el-upload
                      class="upload"
                      :http-request="(opt) => onPickImage(opt, item.index)"
                      :show-file-list="false"
                      accept="image/png,image/jpeg,image/webp"
                    >
                      <el-button
                        type="primary"
                        size="default"
                        >Elegir imagen</el-button
                      >
                    </el-upload>

                    <div
                      v-if="getPreviewSrc(item.config, item.index)"
                      class="preview"
                    >
                      <img
                        :src="getPreviewSrc(item.config, item.index)"
                        alt="Logo"
                      />
                      <div class="actions">
                        <el-button
                          size="default"
                          type="warning"
                          plain
                          @click="clearImage(item.index)"
                          >Quitar</el-button
                        >
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="isDecimalesImportesConfig(item.config)">
                  <el-input-number
                    ref="inputRef"
                    v-model="formList[item.index].Valor"
                    :min="2"
                    :max="8"
                    :step="1"
                    :precision="0"
                    :formatter="formatter"
                    :parser="parser"
                    controls-position="right"
                    size="default"
                    style="width: 100%"
                    @focus="handleFocus"
                    @blur="handleBlur(formList[item.index].Valor)"
                  />
                </template>
                <component
                  :is="getComponent(item.config.TipoComponente)"
                  v-else
                  v-model="formList[item.index].Valor"
                  :placeholder="item.config.Descripcion"
                  :show-password="item.config.TipoComponente?.toLowerCase() === 'password'"
                  :type="
                    item.config.TipoComponente?.toLowerCase() === 'password'
                      ? 'password'
                      : undefined
                  "
                  clearable
                  size="default"
                  style="width: 100%"
                />
              </div>
            </div>
            <div
              v-if="group.modoMargenItems.length"
              class="config-group__modo-margen-row"
            >
              <div
                v-for="item in group.modoMargenItems"
                :key="item.config.Codigo"
                class="config-field"
              >
                <div class="config-field__label">{{ item.config.Descripcion }}</div>
                <p
                  v-if="item.ayuda"
                  class="config-field__help"
                >
                  {{ item.ayuda }}
                </p>
                <el-select
                  v-model="formList[item.index].Valor"
                  placeholder="Seleccionar"
                  clearable
                  size="default"
                  style="width: 100%"
                >
                  <el-option
                    v-for="modo in MODO_MARGEN_OPCIONES_POR_CLAVE[item.config.ClaveInterna]"
                    :key="modo.key"
                    :label="modo.label"
                    :value="modo.key"
                  />
                </el-select>
              </div>
              <div class="config-group__modo-margen-actions">
                <el-tooltip
                  content="Restablecer los modos de cálculo a valores por defecto"
                  placement="top"
                >
                  <el-button
                    size="default"
                    :icon="IconRestore"
                    @click="resetModoMargenDefaults"
                    >Restablecer valores por defecto</el-button
                  >
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        label="Importación de clientes"
        name="import_cliente"
      >
        <import-generic
          label="Clientes"
          api-endpoint="/import/Cliente"
          entity-key="Cliente"
          :fields="[
            { label: 'Descripción', value: 'Descripcion' },
            { label: 'Contacto', value: 'Contacto' },
            { label: 'Email', value: 'Email' },
            { label: 'Teléfono', value: 'Telefono' },
          ]"
          :required-fields="['Descripcion']"
          :props="['CodigoVendedorPrincipal']"
        >
          <template #default="{ params }">
            <custom-ejecutivo-filter
              v-model="params.CodigoVendedorPrincipal"
              v-bind="{
                spanColumn: 6,
                label: 'Vendedor principal',
                settings: {
                  placeholder: 'Seleccionar vendedor',
                  size: 'default',
                },
              }"
              @update:modelValue="(val) => (params.CodigoVendedorPrincipal = val)"
            />
          </template>
        </import-generic>
      </el-tab-pane>
      <el-tab-pane
        label="Producto personalizado"
        name="producto_personalizado"
      >
        <setting-custom-product />
      </el-tab-pane>
      <el-tab-pane
        label="Monedas"
        name="monedas"
      >
        <moneda-setting />
      </el-tab-pane>
      <el-tab-pane
        label="Grupos de elementos"
        name="grupo_elementos"
      >
        <setting-element-group />
      </el-tab-pane>
      <el-tab-pane
        label="Importación de items"
        name="import_material"
      >
        <import-generic
          label="Items"
          api-endpoint="/import/Material"
          entity-key="Material"
          :fields="[
            { label: 'Descripción cliente', value: 'DescripcionCliente' },
            { label: 'Descripción comercial', value: 'DescripcionComercial' },
            { label: 'Codigo Adicional', value: 'CodigoAdicional' },
            { label: 'Costo', value: 'Costo' },
            { label: 'Densidad', value: 'Densidad' },
            { label: 'Espesor', value: 'Espesor' },
            { label: 'Gramaje', value: 'Gramaje' },
            { label: 'Alto', value: 'Alto' },
            { label: 'Ancho', value: 'Ancho' },
            { label: 'Diametro', value: 'Diametro' },
            { label: 'Largo', value: 'Largo' },
            { label: 'Rendimiento', value: 'Rendimiento' },
          ]"
          :required-fields="['DescripcionCliente']"
          :props="['CodigoMaterialTipo', 'CodigoMoneda', 'CodigoUnidadMedida', 'CodigoFamilia']"
        >
          <template #default="{ params, onDisabledButton, updateModelValue }">
            <material-import-form
              :params="params"
              @update:modelValue="updateModelValue"
              @disabled-button="onDisabledButton"
            />
          </template>
        </import-generic>
      </el-tab-pane>
      <el-tab-pane
        label="Importación de suajes"
        name="import_suaje"
      >
        <import-generic
          label="Suajes"
          api-endpoint="/import/Suaje"
          entity-key="Suaje"
          :fields="[
            { label: 'Codigo', value: 'CodigoSuaje' },
            { label: 'Medida al eje', value: 'MedidaEjeMm' },
            { label: 'Medida al desarrollo', value: 'MedidaDesarrolloMm' },
            { label: 'Aplicación', value: 'EsAutomatica' },
            { label: 'Pleca', value: 'TienePleca' },
            { label: 'Tipo corte', value: 'EsCorteCompleto' },
            { label: 'Engrane', value: 'Engranaje' },
            { label: 'Etiquetas eje', value: 'EtiquetasEje' },
            { label: 'Etiquetas desarrollo', value: 'EtiquetasDesarrollo' },
            { label: 'Gap eje', value: 'GapEjeMm' },
            { label: 'Min Etiqueta impresa', value: 'MinEtiquetaImpresa' },
            { label: 'Min Etiqueta Sin impresión', value: 'MinEtiquetaSinImpresion' },
          ]"
          :required-fields="[
            'CodigoSuaje',
            'MedidaEjeMm',
            'MedidaDesarrolloMm',
            'EsAutomatica',
            'TienePleca',
            'EsCorteCompleto',
            'Engranaje',
            'EtiquetasEje',
            'EtiquetasDesarrollo',
            'GapEjeMm',
          ]"
          :props="['CodigoSuajeTipo', 'CodigoForma', 'CodigoTipoCilindro', 'CodigoFamilia']"
        >
          <template #default="{ params, onDisabledButton, updateModelValue }">
            <suaje-import-form
              :params="params"
              @update:modelValue="updateModelValue"
              @disabled-button="onDisabledButton"
            />
          </template>
        </import-generic>
      </el-tab-pane>
      <el-tab-pane
        label="Configuración adicional"
        name="additional_settings"
      >
        <additional-settings />
      </el-tab-pane>
      <el-tab-pane
        label="Roles"
        name="roles"
      >
        <roles-setting />
      </el-tab-pane>
      <el-tab-pane
        label="APIs"
        name="apis"
      >
        <api-settings />
      </el-tab-pane>
      <el-tab-pane
        label="Atributos dinámicos"
        name="atributos_dinamicos"
      >
        <setting-atributos-dinamicos />
      </el-tab-pane>
      <el-tab-pane
        label="Generación de archivos"
        name="generacion_archivos"
      >
        <setting-generate-files />
      </el-tab-pane>
      <el-tab-pane
        label="Sentidos de bobinado"
        name="sentidos_bobinado"
      >
        <setting-sentido-bobinado />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  ref,
  onBeforeUnmount,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import { useMonedaStore } from '@/stores/moneda/moneda_store.js';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import { useLoading } from '@/shared/composables/loading.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import ImportGeneric from '../imports/import_generic.vue';
import CustomEjecutivoFilter from '@/shared/components/custom_ejecutivo_filter.vue';
import SettingCustomProduct from '../components/setting_custom_product.vue';
import SettingElementGroup from '../components/setting_element_group.vue';
import {
  ElMessage,
  ElMessageBox,
} from 'element-plus';
import MonedaSetting from '@/views/setting/components/monedas/moneda_setting.vue';
import MaterialImportForm from '@/shared/components/material_import_form.vue';
import SuajeImportForm from '@/shared/components/suaje_import_form.vue';
import AdditionalSettings from '@/views/setting/components/additional_settings/additional_settings.vue';
import RolesSetting from '@/views/setting/components/roles_settings/roles_setting.vue';
import ApiSettings from '@/views/setting/components/apis/api_settings.vue';
import SettingAtributosDinamicos from '@/views/setting/components/setting_atributos_dinamicos.vue';
import SettingGenerateFiles from '../components/generate_files/setting_generate_files.vue';
import MaterialTipoService from '@/services/material_tipo_service.js';
import MaterialCategoriaService from '@/services/material_categoria_service.js';
import { MaterialGenericoFiltroOptions } from '@/enum/material_generico_filtro.js';
import { SentidoBobinadoConfiguracionOptions } from '@/enum/sentido_bobinado_configuracion.js';
import SettingSentidoBobinado from '@/views/setting/components/sentido_bobinado/setting_sentido_bobinado.vue';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';
import IconRestore from '~icons/mdi/restore';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(0);
const configuracionStore = useConfiguracionStore();
const { configuracionList, configuracionGrupos } = storeToRefs(configuracionStore);
const { updateConfiguracionesHTTP, firstGrupos } = configuracionStore;
const monedaStore = useMonedaStore();
const { monedaList } = storeToRefs(monedaStore);
const { firstMoneda } = monedaStore;
const materialTipoList = ref([]);
const materialCategoriaList = ref([]);
const formRef = ref(null);
const formList = ref([]);
const activeTab = ref('general');
const pendingImages = ref({});
const previewUrls = ref({});
const rotacionOpciones = [
  { key: 0, label: 'Sin rotación' },
  { key: 90, label: '90 grados' },
  { key: 180, label: '180 grados' },
  { key: 270, label: '270 grados' },
];

const calculoCotizacionOpciones = [
  { key: 'margen', label: 'PARAMETRIZABLE' },
  { key: 'markup', label: 'Markup' },
];

const calculoMaterialExtrusionOpciones = [
  { key: 'espesor_densidad', label: 'Espesor + Densidad' },
  { key: 'gramaje', label: 'Gramaje' },
];

const modoUtilidadOpciones = [
  { key: 'markup_sobre_costo', label: 'Markup sobre costo' },
  { key: 'margen_sobre_pv', label: 'Margen sobre precio de venta' },
];

const modoComisionFleteOpciones = [
  { key: 'suma_al_costo', label: 'Se suma al costo' },
  { key: 'agrega_al_precio', label: 'Se agrega al precio' },
  { key: 'porcentaje_pv', label: 'Es % del precio de venta' },
];

const MODO_MARGEN_CLAVES = ['modo_utilidad', 'modo_comision', 'modo_flete'];

const MODO_MARGEN_OPCIONES_POR_CLAVE = {
  modo_utilidad: modoUtilidadOpciones,
  modo_comision: modoComisionFleteOpciones,
  modo_flete: modoComisionFleteOpciones,
};

const MODO_MARGEN_DEFAULTS = {
  modo_utilidad: 'markup_sobre_costo',
  modo_comision: 'porcentaje_pv',
  modo_flete: 'suma_al_costo',
};

const groupedFormList = computed(() => {
  const codeToIndex = {};
  formList.value.forEach((item, i) => {
    codeToIndex[item.Codigo] = i;
  });

  return [...configuracionGrupos.value]
    .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0))
    .map((grupo) => {
      const items = [...(grupo.parametros || [])]
        .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0))
        .map((param) => {
          const idx = codeToIndex[param.codigo];
          if (idx === undefined) return null;
          return { index: idx, config: formList.value[idx], ayuda: param.leyenda || '' };
        })
        .filter(Boolean);
      return {
        claveInterna: grupo.claveInterna,
        title: grupo.titulo,
        description: grupo.leyenda,
        icon: grupo.icono,
        items,
        regularItems: items.filter(
          (item) => !MODO_MARGEN_CLAVES.includes(item.config.ClaveInterna),
        ),
        modoMargenItems: items.filter((item) =>
          MODO_MARGEN_CLAVES.includes(item.config.ClaveInterna),
        ),
      };
    })
    .filter((group) => group.items.length);
});

const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Configuración del sistema', to: null, replace: false },
];
const API_BASE = import.meta.env.VITE_URL_BASE_API || '';
const PUBLIC_BASE = API_BASE.replace(/\/api\/?$/, '');
const isImage = (tipo) => ['image', 'img', 'imagen'].includes((tipo || '').toLowerCase());

const isDecimalesImportesConfig = (config) => config?.ClaveInterna === 'decimales_importes';

const normalizeDecimalesImportes = (valor) => {
  const parsed = Number.parseInt(String(valor ?? '').trim(), 10);
  if (Number.isNaN(parsed)) return 4;
  return Math.max(2, Math.min(parsed, 8));
};

function getPreviewSrc(item, index) {
  const file = pendingImages.value[item.Codigo];
  if (file) return previewUrls.value[item.Codigo];
  if (formList.value[index].Valor) {
    return `${PUBLIC_BASE}/assets/${formList.value[index].Valor}`;
  }
  return '';
}

function beforeUploadImage(file) {
  const okType = ['image/png', 'image/jpeg', 'image/webp'].includes(file.type);
  const okSize = file.size / 1024 / 1024 <= 3;
  if (!okType) {
    ElMessage.error('Formato inválido. Use PNG/JPG/WEBP.');
    return false;
  }
  if (!okSize) {
    ElMessage.error('El archivo supera 3MB.');
    return false;
  }
  return true;
}

function onPickImage({ file }, index) {
  if (!beforeUploadImage(file)) return;
  const item = formList.value[index];
  pendingImages.value[item.Codigo] = file;
  if (previewUrls.value[item.Codigo]) URL.revokeObjectURL(previewUrls.value[item.Codigo]);
  previewUrls.value[item.Codigo] = URL.createObjectURL(file);
  ElMessage.success('Imagen lista para guardar');
}

function clearImage(index) {
  const item = formList.value[index];
  if (previewUrls.value[item.Codigo]) URL.revokeObjectURL(previewUrls.value[item.Codigo]);
  delete previewUrls.value[item.Codigo];
  delete pendingImages.value[item.Codigo];
  formList.value[index].Valor = '';
}

async function fetchMaterialTipo() {
  const response = await MaterialTipoService.findAll({
    page: 0,
    Activo: true,
    sortBy: 'Descripcion',
    sort: 'asc',
  });
  materialTipoList.value = response.data || [];
}

async function fetchMaterialCategoria() {
  const response = await MaterialCategoriaService.findAll({
    page: 0,
    Activo: true,
    sortBy: 'Descripcion',
    sort: 'asc',
  });
  materialCategoriaList.value = response.data || [];
}

onMounted(async () => {
  await firstGrupos();
  await firstMoneda();

  await fetchMaterialTipo();
  await fetchMaterialCategoria();
  formList.value = [...configuracionList.value]
    .sort((a, b) => (a.Orden ?? 0) - (b.Orden ?? 0))
    .map((item) => {
      const tipo = item.TipoComponente?.toLowerCase();
      let valor = item.Valor;

      if (isDecimalesImportesConfig(item)) {
        valor = normalizeDecimalesImportes(valor);
      } else if (tipo === 'number') {
        valor = parseFloat(valor);
      }
      if (tipo === 'switch' || tipo === 'boolean') {
        valor = valor === true || valor === '1' || valor === 'true' || valor === 'True';
      }

      if (tipo === 'select') {
        if (item.ClaveInterna === 'rotacion_imposicion') {
          // `valor` viene de ConfiguracionGeneral como texto y las keys son numeros.
          valor = rotacionOpciones.find((rotacion) => rotacion.key === Number(valor))?.key;
        } else if (item?.ClaveInterna === 'modo_calculo_precio') {
          const normalizado = (valor ?? '').toString().trim().toLowerCase();
          valor =
            calculoCotizacionOpciones.find((modo) => modo.key === normalizado)?.key || 'margen';
        } else if (item?.ClaveInterna === 'calculo_material_extrusion') {
          const normalizado = (valor ?? '').toString().trim().toLowerCase();
          valor =
            calculoMaterialExtrusionOpciones.find((opcion) => opcion.key === normalizado)?.key ||
            'espesor_densidad';
        } else if (item?.ClaveInterna === 'filtro_generico_material_defecto') {
          const normalizado = (valor ?? '').toString().trim().toUpperCase();
          valor =
            MaterialGenericoFiltroOptions.find((opcion) => opcion.Codigo === normalizado)?.Codigo ||
            'TODOS';
        } else if (item?.ClaveInterna === 'sentido_bobinado_configuracion') {
          const normalizado = (valor ?? '').toString().trim().toLowerCase();
          valor =
            SentidoBobinadoConfiguracionOptions.find((opcion) => opcion.Codigo === normalizado)
              ?.Codigo || 'sistema';
        } else if (MODO_MARGEN_CLAVES.includes(item.ClaveInterna)) {
          const normalizado = (valor ?? '').toString().trim().toLowerCase();
          valor =
            MODO_MARGEN_OPCIONES_POR_CLAVE[item.ClaveInterna].find(
              (modo) => modo.key === normalizado,
            )?.key || MODO_MARGEN_DEFAULTS[item.ClaveInterna];
        } else {
          const parsed = parseInt(valor, 10);
          valor = Number.isNaN(parsed) ? valor : parsed;
        }
      }
      return {
        ...item,
        Valor: valor,
      };
    });
});

const getComponent = (tipo) => {
  switch (tipo?.toLowerCase()) {
    case 'number':
      return 'el-input-number';
    case 'switch':
      return 'el-switch';
    case 'text':
      return 'el-input';
    case 'password':
      return 'el-input';
    case 'boolean':
      return 'el-switch';
    default:
      return 'el-input';
  }
};

onBeforeUnmount(() => {
  Object.values(previewUrls.value).forEach((url) => URL.revokeObjectURL(url));
});

async function resetModoMargenDefaults() {
  try {
    await ElMessageBox.confirm(
      'Se restablecerán el modo de utilidad, comisión y flete al comportamiento por defecto del sistema (markup sobre costo, comisión % del precio de venta y flete sumado al costo). Los cambios se guardarán al presionar "Guardar".',
      'Restablecer valores por defecto',
      {
        confirmButtonText: 'Restablecer',
        cancelButtonText: 'Cancelar',
        type: 'warning',
      },
    );
  } catch {
    return;
  }

  formList.value = formList.value.map((item) => {
    if (!MODO_MARGEN_CLAVES.includes(item.ClaveInterna)) return item;
    return { ...item, Valor: MODO_MARGEN_DEFAULTS[item.ClaveInterna] };
  });

  ElMessage.success('Valores restablecidos. Recordá presionar "Guardar" para confirmar.');
}

const onSave = async () => {
  try {
    useLoading().openLoading();
    formList.value = formList.value.map((item) => {
      if (!isDecimalesImportesConfig(item)) return item;
      return {
        ...item,
        Valor: normalizeDecimalesImportes(item.Valor),
      };
    });
    await updateConfiguracionesHTTP(formList.value, pendingImages.value);
    configuracionStore.syncValoresLocales(formList.value);
    Object.values(previewUrls.value).forEach((url) => URL.revokeObjectURL(url));
    previewUrls.value = {};
    pendingImages.value = {};

    useMessageSuccess().open('Los datos se guardaron existosamente!');
  } catch (error) {
    useMessageError().open('Ha ocurrido un error al intentar guardar los datos.');
  } finally {
    useLoading().closeLoading();
  }
};
</script>

<style scoped>
.scroll-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 40px 30px;
  background-color: #fff;
}
.form-wrapper {
  width: 100%;
}

.config-group {
  border: 1px solid #ebeef0;
  border-radius: 10px;
  background: #fbfbfc;
  padding: 22px 24px;
  margin-bottom: 24px;
}

.config-group__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.config-group__header-text {
  flex: 1 1 auto;
}

.config-group__icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #eef2ff;
  color: #4f46e5;
}

.config-group__icon :deep(svg) {
  width: 20px;
  height: 20px;
}

.config-group__title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.config-group__subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #6b7280;
}

.config-group__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px 24px;
}

.config-group__modo-margen-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px 24px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px dashed #e5e7eb;
}

.config-group__modo-margen-row .config-field {
  flex: 1 1 260px;
  min-width: 260px;
}

.config-group__modo-margen-actions {
  flex: 0 0 auto;
  padding-bottom: 1px;
}

.config-field {
  display: flex;
  flex-direction: column;
}

.config-field__label {
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.config-field__help {
  margin: 0 0 10px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #8a8f98;
}
.img-field .preview {
  margin-top: 8px;
  max-width: 420px;
}
.img-field .preview img {
  max-width: 100%;
  max-height: 140px;
  object-fit: contain;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  padding: 6px;
}
.img-field .actions {
  margin-top: 8px;
}
</style>
